import { render, staticRenderFns } from "./xuanzMb.vue?vue&type=template&id=0219a412&scoped=true"
import script from "./xuanzMb.vue?vue&type=script&lang=js"
export * from "./xuanzMb.vue?vue&type=script&lang=js"
import style0 from "./xuanzMb.vue?vue&type=style&index=0&id=0219a412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219a412",
  null
  
)

export default component.exports